module.exports = __webpack_public_path__ + "img/cgm pay.e94d541b.png";